'use strict';

import React from 'react';
import Modal from 'react-modal';
import classNames from 'classnames';
import platform from 'platform';
import PropTypes from 'prop-types';

import RecipeEditor from '../Editor.react';

/**
 * RecipeEditorModal - Functional React component for editing recipes using el-modal1 framework
 *
 * Upgraded from class component to functional component with modern el-modal1 styling
 * and responsive mobile/desktop support.
 */
const RecipeEditorModal = ({
    profile,
    uuid,
    title,
    onSave,
    closeModal,
    saveBtnText,
    usedFromContext
}) => {
    // Determine if mobile (basic detection for modal styling)
    const isMobile = window.innerWidth <= 768;
    const isCordova = window.cordova !== undefined;

    // Modal classes using el-modal1 framework
    const modalClasses = classNames('el-modal', 'el-modal1', 'recipe-editor-modal', {
        'is-mobile': isMobile,
        'is-cordova': isCordova,
        'safari-mobile': platform.name === 'Safari' && isMobile,
    });

    const containerClasses = classNames(
        'el-modal-container', 
        'el-modal1-container', 
        'el-modal1-recipe-editor-container'
    );

    return (
        <Modal
            isOpen={true}
            onRequestClose={closeModal}
            className={modalClasses}
            overlayClassName="el-modal-overlay"
            contentLabel="Edit Recipe Details"
            closeTimeoutMS={250}
        >
            <section className={containerClasses}>
                {/* Header using el-modal1 pattern */}
                <header data-has-controls="false">
                    <button
                        onClick={closeModal}
                        className="el-modal-back-btn"
                        title="Close recipe editor"
                    >
                        <span>Back</span>
                    </button>
                    
                    <h2>{title || 'Edit Recipe'}</h2>
                </header>

                {/* Main content area */}
                <div className="el-modal-body-container el-modal1-body-container">
                    <RecipeEditor
                        uuid={uuid}
                        profile={profile}
                        closeModal={closeModal}
                        onSaveRecipe={onSave}
                        usedFromContext={usedFromContext}
                        saveDirtyBtnText={saveBtnText}
                    />
                </div>
            </section>
        </Modal>
    );
};

RecipeEditorModal.propTypes = {
    profile: PropTypes.object,
    uuid: PropTypes.string,
    title: PropTypes.string,
    onSave: PropTypes.func,
    closeModal: PropTypes.func,
    saveBtnText: PropTypes.string,
    usedFromContext: PropTypes.any,
};

export default RecipeEditorModal;
